import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ReusableModal from "../../Components/Modal";
import Call from "../../Components/Call";

const RescheduleMaster = () => {
  const [sessionList, setSessionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [dateFilter, setDateFilter] = useState({
    startDate: "",
    endDate: "",
  });
  const [sessionCount, setSessionCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [singleSession, setSingleSession] = useState({});

  useEffect(() => {
    fetchUserSessionList(pageData.currentPage, entries);
  }, [pageData.currentPage, entries]);

  useEffect(() => {
    if (dateFilter.startDate !== "" && dateFilter.endDate !== "") {
      fetchUserSessionList(
        pageData.currentPage,
        entries,
        dateFilter.startDate,
        dateFilter.endDate
      );
    }
  }, [dateFilter.startDate, dateFilter.endDate]);

  const fetchUserSessionList = async (current, count, start, end) => {
    setLoading(true);
    let url = "";
    if (start && end && start > end) {
      toast.error("End date cannot be earlier than the start date");
      return;
      // url = `user-sessions?status=Reschedule&page=${current}&per_page=${count}`;
    } else if (start && end && start < end) {
      url = `user-sessions?status=Reschedule&page=${current}&per_page=${count}&startDate=${start}&endDate=${end}`;
    } else {
      url = `user-sessions?status=Reschedule&page=${current}&per_page=${count}`;
    }
    try {
      const getSessionList = await axiosHttp.get(url);
      if (getSessionList.status === 200) {
        let data = getSessionList.data.data;
        let pageValue = getSessionList.data.currentPage;
        let totalPageValue = getSessionList.data.lastPage;
        setPageData({
          currentPage: pageValue,
          totalPages: totalPageValue,
        });
        setSessionList(data);
        fetchSessionCount(current, count, start, end);
      }
    } catch (error) {
      console.log(error);
      setSessionList([]);
      setLoading(false);
    }
  };

  const fetchSessionCount = async (current, count, start, end) => {
    let url = "";
    if (start && end && start > end) {
      url = `user-sessions-count?status=Reschedule&page=${current}&per_page=${count}`;
    } else if (start && end && start < end) {
      url = `user-sessions-count?status=Reschedule&page=${current}&per_page=${count}&startDate=${start}&endDate=${end}`;
    } else {
      url = `user-sessions-count?status=Reschedule&page=${current}&per_page=${count}`;
    }
    try {
      const getSessionCount = await axiosHttp.get(url);
      if (getSessionCount.status === 200) {
        let data = getSessionCount.data.data;
        setSessionCount(data.count);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSessionCount(0);
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteUser = await axiosHttp.delete(`user/${id}`);
      if (deleteUser.status === 200) {
        setLoading(true);
        toast.success(deleteUser.data.message);
        fetchUserSessionList(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDateFilter({ ...dateFilter, [name]: value });
  };

  const openModal = (sess) => {
    setSingleSession(sess);
    setShowModal(true);
  };

  const closeModal = () => {
    setSingleSession({});
    setShowModal(false);
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <huserCount4 className="title mb-5">Reschedule Master</huserCount4>
          <div className="row mt-5 mb-5">
            <div className="col-md-5">
              <div className="row">
                <div className="col-md-5">
                  <h5 className="head">Reschedule List</h5>
                </div>
              </div>
            </div>
            <div className="col-md-7 text-right">
              <div className="row align-items-center justify-content-end">
                <div className="col-md-3">
                  <label>Date Filter</label>
                </div>
                <div className="col-md-4">
                  <input
                    className="form-control"
                    type="date"
                    name="startDate"
                    value={dateFilter.startDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 d-flex align-items-center">
                  <label className="mr-2">-</label>
                  <input
                    className="form-control"
                    type="date"
                    name="endDate"
                    value={dateFilter.endDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-end mr-2">
            <div className="text-right">
              <p className="text-danger">{sessionCount} sessions</p>
            </div>
          </div>

          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th>
                    <input type="checkbox" class="form-control w-25 " />
                  </th>
                  <th>Date</th>
                  <th>Title</th>
                  <th>Reschedule reason</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sessionList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {sessionList.length > 0 &&
                  sessionList.map((sess) => {
                    return (
                      <tr key={sess.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td class="border-right-0 ">
                          {moment(sess?.end_time).format("DD.MM.YYYY")}
                        </td>
                        <td class="border-right-0 ">{sess?.service_name} </td>
                        <td class="border-right-0 ">{sess?.comments} </td>

                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEye}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => openModal(sess)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(sess.user_id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="d-flex mt-5 justify-content-between ">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={(e) => setEntries(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
            {pageData.totalPages > 1 && (
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageData.totalPages}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination justify-content-end"
                activeClassName="active"
                previousLabel="<"
                forcePage={pageData.currentPage - 1}
              />
            )}
          </div>
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title="View Reschedule Call"
        size="lg"
      >
        <Call sess={singleSession} reason="Reaschedule reason" />
      </ReusableModal>
    </div>
  );
};

export default RescheduleMaster;
